import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import setFieldValue from "@insite/client-framework/Store/Components/ContactUsForm/Handlers/SetFieldValue";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ContactFormContext } from "@insite/content-library/Widgets/ContactUs/ContactForm";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const enum fields {
    label = "label",
    hintText = "hintText",
    isRequired = "isRequired",
    maininput = "maininput"
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.label]: string;
        [fields.hintText]: string;
        [fields.isRequired]: boolean;
        [fields.maininput]: string;
    };
}

const mapStateToProps = (state: ApplicationState) => ({
    supplierName: state.components.contactUsForm.fieldValues["supplierName"],
});

const mapDispatchToProps = {
    setFieldValue,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface SupplierNameStyles {
    supplierNameTextField?: TextFieldPresentationProps;
    maininput?: InjectableCss;
}

export const supplierNameStyles: SupplierNameStyles = {
    maininput: {
        css: css`
             ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    null,
                    null,
                    css`
                     [class^="FormFieldStyle"]{
                     display: inline;
            }  
                `,
                ])} 
        `
    },
    supplierNameTextField: {
        css: css`
          ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    null,
                    null,
                    css`
                     width: 55% !important;
                     float: right;
                `,
                ])} 
       
        `,
        labelProps: {
            css: css`
               ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        null,
                        null,
                        null,
                        null,
                        css`
                     width: 40% !important;
                     float: left;
                     margin-top: 5px;
                `,
                    ])} 
            `
        },
    },
}
const styles = supplierNameStyles;

const SupplierName: React.FC<Props> = ({ fields, supplierName, setFieldValue }) => {
    const { label, hintText, isRequired } = fields;
    const contactFormContext = React.useContext(ContactFormContext);
    const [supplierNameErrorMessage, setSupplierNameErrorMessage] = React.useState("");

    React.useEffect(() => {
        contactFormContext.validators.supplierName = validateSupplierName;
        if (typeof supplierName !== "undefined") {
            validateSupplierName();
        }
    }, [supplierName]);

    React.useEffect(() => {
        contactFormContext.validators.supplierName = validateSupplierName;
    }, [isRequired]);

    const validateSupplierName = () => {
        const errorMessage = isRequired && !supplierName ? (siteMessage("Field_Required", label) as string) : "";
        setSupplierNameErrorMessage(errorMessage);
        return !errorMessage;
    };

    const supplierNameChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFieldValue({ key: "supplierName", value: event.target.value });
    };

    return (
        <>
            <StyledWrapper {...styles.maininput}>
                <TextField
                    {...styles.supplierNameTextField}
                    label={label}
                    required={isRequired}
                    // placeholder={hintText}
                    value={supplierName || ""}
                    error={supplierNameErrorMessage}
                    onChange={supplierNameChangeHandler}
                />
            </StyledWrapper>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(SupplierName),
    definition: {
        group: "Contact Us",
        icon: "input-pipe",
        fieldDefinitions: [
            {
                name: fields.label,
                displayName: "Label",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                defaultValue: "Supplier",
                isRequired: true,
            },
            {
                name: fields.hintText,
                displayName: "Hint Text",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                defaultValue: "",
                isRequired: true,
            },
            {
                name: fields.isRequired,
                displayName: "Required Field",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
